import { Loader2 } from "lucide-react"
import { Loader } from 'lucide-react';

interface FullScreenLoadingProps {
    title?: string;
}


export const FullScreenLoading = ({ title = "Loading..." }: FullScreenLoadingProps) => {
    return (
        <>
            <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/40">
                <Loader className="h-10 w-10 animate-spin" />
                <p className="mt-1 text-md text-white">{title}</p>
            </div>
        </>
    )
}


export const LoadingTransactions = () => {
    return (
        <>
            <div className="flex flex-col items-center justify-center gap-3 text-[#5B9BD5]">
                <Loader2 className="h-8 w-8 animate-spin" />
                <span className="font-medium text-sm">
                    Loading transactions...
                </span>
            </div>
        </>
    )
}